import project0 from '../assets/images/projects/project0.webp';
import project1 from '../assets/images/projects/project1.webp';
import project2 from '../assets/images/projects/project2.webp';
import project3 from '../assets/images/projects/project3.webp';
import project4 from '../assets/images/projects/project4.webp';
import project5 from '../assets/images/projects/project5.webp';

const projects = [
    {
        title: "WriteBetter",
        description: "WriteBetter is an AI-powered writing assistant that helps users refine their writing by enhancing clarity, vocabulary, and style.",
        image: project0,
        link: "https://github.com/duyquangbui99/writebetter-react",
        stack: ["React", "Firebase", "OpenAI"]
    },
    {
        title: "VidSummarizer",
        description: "AI-driven web application designed to automatically generate concise summaries from YouTube video transcripts.",
        image: project1,
        link: "https://github.com/duyquangbui99/VidSummarizer",
        stack: ["Python", "Langchain", "Js"]
    },
    {
        title: "Math Bingo",
        description: "Classic game of bingo turned into a math learning game by calling out math problems for kids to solve and mark on their bingo cards.",
        image: project2,
        link: "https://github.com/duyquangbui99/math-bingo",
        stack: ["Javascript", "HTML", "CSS"]
    },
    {
        title: "Rule-Based ChatBot",
        description: "Web-based virtual assistant designed to provide quick responses to common questions about a business by fetching data from JSON.",
        image: project3,
        link: "https://github.com/duyquangbui99/Support-Chatbot",
        stack: ["Javascript", "HTML", "CSS"]
    },
    {
        title: "Game Development",
        description: "This C# game focuses on robust navigation systems through navmesh creation, ensuring precise character and object pathfinding.",
        image: project4,
        link: "https://github.com/duyquangbui99/NavMeshComponent",
        stack: ["C#", "Unity"]
    },
    {
        title: "Sudoku Solver",
        description: "Python program that allows you to play and solve Sudoku puzzles. It uses the Tkinter library to create GUI for the game.",
        image: project5,
        link: "https://github.com/duyquangbui99/SudokuSovlerPython",
        stack: ["Python", "Tkinter"]
    }
];

export default projects;
